const ACTIONS = {
  /*
        Actions based on error responses
    */
  HIDE_PLANS: 'HIDE_PLANS',
  HIDE_PLANS_ELECTRICITY: 'HIDE_PLANS_ELECTRICITY',
  HIDE_PLANS_GAS: 'HIDE_PLANS_GAS',
  PARTIALLY_ELIGIBLE_GAS: 'PARTIALLY_ELIGIBLE_GAS',
  PARTIALLY_ELIGIBLE_ELECTRICITY: 'PARTIALLY_ELIGIBLE_ELECTRICITY',
  NO_SOLAR: 'NO_SOLAR',

  /*
     Actions based on filter updates
     */
  UPDATE_PLAN: 'UPDATE_PLAN',
  UPDATE_PREDICTED_ELECTRICITY: 'UPDATE_PREDICTED_ELECTRICITY',
  UPDATE_PREDICTED_GAS: 'UPDATE_PREDICTED_GAS',
  SWITCHED_TO_CUSTOM_ENERGY: 'SWITCHED_TO_CUSTOM_ENERGY',
};

export default ACTIONS;
